/**
 * @file 条形进度条
 * @author liuhanwei
 */
import React from 'react';
import classNames from 'classnames';
import MultiToneSuccess from 'acud-icon/lib/icons/MultiToneSuccess';
import MultiToneError from 'acud-icon/lib/icons/MultiToneError';
import { sizeRatioMap, isNumber } from './common';
const LineProgress = ({ percent = 0, type = 'line', status, size, strokeColor, iconStrokeColor, infoType = 'text', trailColor, textColor, textSize, labelText, strokeLinecap = 'round', strokeWidth: customizeStrokeWidth, infoPosition: customizeInfoPosition = 'outer', style, className, prefixCls }) => {
    const BASE_LINE_WIDTH = 4;
    // strokeWidth取值异常时，将使用size对应的宽度
    const strokeWidth = isNumber(customizeStrokeWidth) ? customizeStrokeWidth : sizeRatioMap[size] * BASE_LINE_WIDTH;
    // 最外层容器的类名，将所有状态类名尽可能地代理到这层处理
    const extendedName = classNames(prefixCls, `${prefixCls}-${type}`, `${prefixCls}-${size}`, `${prefixCls}-${status}`, {
        // infoType取值none，则不显示进度信息
        [`${prefixCls}-label-hidden`]: infoType === 'none',
        // strokeLinecap取值不为square，则认为全是圆角
        [`${prefixCls}-linecap-round`]: strokeLinecap !== 'square'
    }, className);
    // 设置进度条宽度
    const wrapperStyles = {
        height: `${strokeWidth}px`
    };
    // 设置进度轨道颜色
    const trailStyles = {
        backgroundColor: trailColor
    };
    // 设置进度百分比长度和颜色
    const barStyles = {
        width: `${percent}%`,
        backgroundColor: strokeColor
    };
    // 当infoPosition值为inner或infoType值为icon，信息显示在进度条外
    const infoPosition = customizeInfoPosition !== 'inner' || infoType === 'icon' ? 'outer' : 'inner';
    // 当文本显示在进度条内时，进度小于50，显示在未完成部分；大于50，显示在完成部分
    const innerLabelPosition = percent < 50 ? 'right' : 'left';
    // 设置自定义文本样式
    const labelStyles = {
        color: textColor,
        fontSize: `${textSize}px`
    };
    const labelClassNames = classNames(`${prefixCls}-label`, `${prefixCls}-label-${infoPosition}`, {
        [`${prefixCls}-label-icon`]: infoType === 'icon',
        [`${prefixCls}-label-inner-${innerLabelPosition}`]: infoPosition === 'inner'
    });
    let ProgressLabel = (<span className={labelClassNames} style={labelStyles}>{labelText}</span>);
    // 若信息类型为图标，在成功和异常时，显示图标
    if (infoType === 'icon') {
        if (status === 'success') {
            ProgressLabel = (<MultiToneSuccess className={labelClassNames} color={iconStrokeColor} width="16px"/>);
        }
        else if (status === 'error') {
            ProgressLabel = (<MultiToneError className={labelClassNames} color={iconStrokeColor} width="16px"/>);
        }
    }
    return (<div className={extendedName} style={style}>
            <div className={`${prefixCls}-wrapper`} style={wrapperStyles}>
                <div className={`${prefixCls}-trail`} style={trailStyles}>
                    <div className={`${prefixCls}-bar`} style={barStyles}>
                        {infoPosition === 'inner' && ProgressLabel}
                    </div>
                </div>
            </div>
            {infoPosition === 'outer' && ProgressLabel}
        </div>);
};
export default LineProgress;
